import { FC } from 'react'
import Card from 'components/Card'
import { Logo } from 'components/ui'
import Version from 'components/Version'
import { AppProject } from 'components/app-project'

const LoginShell: FC = ({ children }): JSX.Element => {
  const date = new Date()
  const year = date.getFullYear()
  return (
    <div className="container flex flex-col items-center h-full max-w-full min-h-screen bg-primary">
      <div className="flex flex-col justify-between w-full h-full min-h-screen md:w-6/12 lg:w-5/12 xl:w-1/3">
        <div className="flex items-center justify-center mt-16 text-white">
          <Logo width={250} />
        </div>

        {process.env.REACT_APP_ENV === 'staging' && (
          <div className="flex items-center justify-center text-center text-red text-4xl font-bold">
            You are currently using the UAT Environment
          </div>
        )}

        <Card className="flex flex-col items-center p-10 bg-white">
          {children}
        </Card>

        <div className="container flex flex-col items-center my-6 text-white gap-1">
          <Logo width={110} />
          <div className="flex items-center justify-center gap-2">
            <Version />
            <AppProject />
          </div>
        </div>
      </div>
    </div>
  )
}

export default LoginShell
